module.exports = __webpack_public_path__ + "static/media/10x_logo.96b4b606.svg";